import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthService from "../services/authServise";
import { parseQueryParams } from "../utils/helpers";
import "./Login.css";
import WaitSpinner from "../components/WaitSpinner";

function Login() {
  const authService = new AuthService();
  const [loginInProcess, setLoginInProcess] = useState(false);
  const [loginSuccessfully, setLoginSuccessfully] = useState();

  const redirect = async (ms) => {
    await new Promise((resolve) => setTimeout(resolve, ms));
    window.location.assign("../info");
  };

  useEffect(() => {
    try {
      if (window.location.search !== "" && loginInProcess === false) {
        setLoginInProcess(true);
        const query = parseQueryParams(window.location.search);
        if (query) {
          if (query.code) {
            setLoginSuccessfully(true);
            authService.authCallBack(query.code);
            redirect(1500);
          } else if (query.error) {
            setLoginSuccessfully(false);
          }
        }
        
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("--ERROR", error);
      redirect(100);
    }
  }, [authService]);

  if(loginSuccessfully) {
    return ( <WaitSpinner /> );
  }else{
    return (
      <div className="text-center"><h1>Access Denied</h1>
      <Link to="/logout" className="btn btn-logout pt-2">Go Back</Link></div>
    );
  }
}

export default Login;
